import Swiper from 'swiper/js/swiper.min';

$(function () {
	if ($('#jsAttentionCompany').length > 0) {
		var swiper = new Swiper('#jsAttentionCompany', {
			// initialSlide: 1,
			loop: true,
			slidesPerGroup: 1,
			loopAdditionalSlides: 4,
			centeredSlides: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			pagination: {
				el: '.attention-slider-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.attention-slider-button-next',
				prevEl: '.attention-slider-button-prev',
			},
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		});
	};
	if ($('#jsInterview').length > 0 && $('.interview-item').length > 1) {
		var swiper = new Swiper('#jsInterview', {
			loop: true,
			loopAdditionalSlides: 4,
			slidesPerGroup: 1,
			centeredSlides: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		});
	};
	if ($('#jsExperience').length > 0) {
		var swiper = new Swiper('#jsExperience', {
			loop: true,
			loopAdditionalSlides: 4,
			slidesPerGroup: 1,
			centeredSlides: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		});
	};
	if ($('#jsNew').length > 0) {
		var swiper = new Swiper('#jsNew', {
			loop: true,
			loopAdditionalSlides: 4,
			slidesPerGroup: 1,
			centeredSlides: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		});
	};
	if ($('#jsEvent').length > 0) {
		var swiper = new Swiper('#jsEvent', {
			loop: true,
			loopAdditionalSlides: 4,
			slidesPerGroup: 1,
			centeredSlides: false,
			autoplay: 3000,
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		});
	};
	if ($('#jsInfo').length > 0) {
		var swiper = undefined;
		var winW = window.innerWidth;
		var swiperElement = document.getElementById("jsInfo");
		var swiperWrapper = swiperElement.getElementsByClassName("swiper-wrapper");
		var swiperSlide = swiperElement.getElementsByClassName("swiper-slide");
		var options = {
			loop: true,
			loopAdditionalSlides: 4,
			slidesPerGroup: 1,
			centeredSlides: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 1000,
			slidesPerView: 1,
			spaceBetween: 15,
			breakpoints: {
				576: {
					spaceBetween: 20
				},
				992: {
					spaceBetween: 30
				},
			}
		};
		function initSwiper() {
			if (swiperElement) {
				var screenWidth = window.innerWidth;
				if (screenWidth < 992 && swiper == undefined) {
					swiper = new Swiper('#jsInfo', options);
				} else if (screenWidth > 991 && swiper != undefined) {
					swiper.destroy();
					swiper = undefined;
					for (var i = 0; i < swiperWrapper.length; i++) {
						swiperWrapper[i].removeAttribute('style');
					}
					for (var i = 0; i < swiperSlide.length; i++) {
						swiperSlide[i].removeAttribute('style');
					}
				}
			}
		}
		initSwiper();

		window.addEventListener('resize', initSwiper);
	};
});
